module.exports = __webpack_public_path__ + "tables/media/notify.69345319.svg";